import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";

import { useMainStore } from "@/contexts/Store";

import arrowUp from "../../../images/table-image/icon/arrow-up.svg";
import checkIcon from "../../../images/table-image/icon/check-icon.svg";
import publicIcon from "../../../images/table-image/icon/public-icon.svg";

type Props = {
  initialValue?: string;
  moduleWorkspaceID?: number;
};

function NewSectionInput({ initialValue, moduleWorkspaceID }: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [title, setTitle] = useState("");

  // Refs
  const titleRef = useRef();

  // Effects
  useEffect(() => {
    if (
      mainStore.sectionTags.current &&
      mainStore.sectionTags.current.title == title
    ) {
      setTitle("");
    } else {
      setTitle("SOC II Type I");
    }
  }, [mainStore.sectionTags.current]);

  useEffect(() => {
    // It won't work without a small timeout :(
    setTimeout(() => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      titleRef.current.focus();
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      titleRef.current.select();
    }, 10);
  }, []);

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  function onTitleChange(event) {
    setTitle(event.target.value);
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      if (title && title.length > 0) {
        mainStore.sectionTags.create(moduleWorkspaceID, { title });
      }
    }
  }

  function doneClick() {
    if (title && title.length > 0) {
      mainStore.sectionTags.create(moduleWorkspaceID, { title });
    }
  }

  return (
    <div className="dropdown-title-wrap">
      <div className="dropdown-title">
        <div className="dropdown-arrow">
          <img src={arrowUp} alt="dropdown-arrow" />
        </div>
        <input
          type="text"
          // @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
          ref={titleRef}
          className="new-section-tag"
          data-testid="new-section-tag-input"
          value={title}
          onChange={onTitleChange}
          onKeyDown={handleKeyDown}
          defaultValue={initialValue}
        />
        <div className="dropdown-check-icon" onClick={doneClick}>
          <img src={checkIcon} alt="icon" />
        </div>
        <img src={publicIcon} alt="public-icon" />
      </div>
    </div>
  );
}

export default observer(NewSectionInput);
